// extracted by mini-css-extract-plugin
export default {"price":"L9-z","onSale":"M9-z","msrpLabelPrice":"N9-z","msrpLabel":"O9-z","originalPrice":"P9-z","percentOff":"Q9-z"};